import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';

export function EntityProcedureCollapseToggle() {
  return (
    <span
      data-procedure-toggle
      className="flex size-6 shrink-0 items-center justify-center rounded-full transition-all duration-200"
      data-testid={DataTestIdEnum.ENTITY_PROCEDURE_SCHEDULE_CARD_TOGGLE}
    >
      <Icon icon={faAngleDown} className="size-5 text-gray-700" />
    </span>
  );
}
